import { render, staticRenderFns } from "./PowerStatistics.vue?vue&type=template&id=547e99e8&scoped=true&"
import script from "./PowerStatistics.vue?vue&type=script&lang=js&"
export * from "./PowerStatistics.vue?vue&type=script&lang=js&"
import style0 from "./PowerStatistics.vue?vue&type=style&index=0&id=547e99e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547e99e8",
  null
  
)

export default component.exports